module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo d-none d-sm-inline d-xl-inline",
    attrs: {
      "src": require("assets/img/logo.png"),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Endereço incompleto...")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.url) ? _c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n    Por exemplo: "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.url) + "/"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("url-da-clinica")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Para acessar essa página você deve fornecer a "), _c('i', [_vm._v("URL")]), _vm._v(" da sua clínica de medicina do Trabalho.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7331f698"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/template/511.vue
// module id = 1505
// module chunks = 45